import { render } from "./ToolTip.vue?vue&type=template&id=3dc8f21a&scoped=true"
import script from "./ToolTip.vue?vue&type=script&lang=js"
export * from "./ToolTip.vue?vue&type=script&lang=js"

import "./ToolTip.vue?vue&type=style&index=0&id=3dc8f21a&lang=css&scoped=true"

import exportComponent from "/home/apriyadi/projects/lifetime/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc8f21a"]])

export default __exports__